import { SET_GOLOBAL_THEME_MODE } from "./type.action";

export const setThemeMode = (mode) => {
  return { type: SET_GOLOBAL_THEME_MODE, payload: mode };
};